import { API_CONFIG } from '../../config/urls'

export const urlBuilder = {
  api: (path: string): string => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path
    return `${API_CONFIG.BASE_URL}/${cleanPath}`
  },

  adminApi: (path: string): string => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path
    return `${API_CONFIG.ADMIN_URL}/${cleanPath}`
  },
  
  storage: (path: string): string => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path
    return `${API_CONFIG.STORAGE_URL}/${cleanPath}`
  }
}